module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img247-a9bcf01958d45e625180b81590ce27f0.jpg";